module.exports = __webpack_public_path__ + "static/media/Icon_Book.6a723a6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Book.svg
// module id = 2303
// module chunks = 0